import { MobileLayout, LayoutType, BlockRef, MetaType } from "../types"
import {
  actionCreatorGuard,
  reducerActions,
  reducerGuard,
  processActionMeta,
  getArrayReducerGuard
} from "../reducers"

const kind = "seq_assessments"

export type SeqAssessment = {
  kind: typeof kind
  version: number
  name: string
  description: string
  layout: LayoutType
  mobileLayout: MobileLayout
  left: Array<BlockRef>
  right: Array<BlockRef>
  meta: MetaType
}

export const reducerAction = {
  meta: actionCreatorGuard<SeqAssessment, MetaType>("meta", kind),
  left: actionCreatorGuard<SeqAssessment, Array<BlockRef>>("left", kind),
  right: actionCreatorGuard<SeqAssessment, Array<BlockRef>>("right", kind),
  layout: actionCreatorGuard<SeqAssessment, LayoutType>("layout", kind),
  mobileLayout: actionCreatorGuard<SeqAssessment, MobileLayout>(
    "mobileLayout",
    kind
  ),
  name: actionCreatorGuard<SeqAssessment, string>("name", kind),
  description: actionCreatorGuard<SeqAssessment, string>("description", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<
    SeqAssessment,
    "kind" | "version"
  >]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const seqAssessmentAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const seqAssessmentReducer = reducerGuard<SeqAssessment>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.left)
  .case(...reducerAction.right)
  .case(...reducerAction.layout)
  .case(...reducerAction.mobileLayout)
  .case(...reducerAction.name)
  .case(...reducerAction.description)
  .default((prevState, action: any) => {
    action = processActionMeta(action)

    switch (action?.meta?.prop) {
      case "left":
        return getArrayReducerGuard<SeqAssessment, BlockRef>(
          kind,
          "left",
          "BlockRef",
          prevState,
          action
        )
      case "right":
        return getArrayReducerGuard<SeqAssessment, BlockRef>(
          kind,
          "right",
          "BlockRef",
          prevState,
          action
        )
    }

    return prevState
  })
